import calc from '../../Assets/Images/Calculator.png'
import note from '../../Assets/Images/StickyNote.png'
import clock from '../../Assets/Images/Clock.png'
import loginApi from '../../Assets/Images/LoginApi.png'
import cars from '../../Assets/Images/Cars.png'
import Mophy from '../../Assets/Images/MophyPayment.png'
import School from '../../Assets/Images/SouthWest.png'
import GYM from '../../Assets/Images/Gym.png'
import HouseOfPraise from '../../Assets/Images/HouseOfPraise.png'
import Jesdworld from '../../Assets/Images/Jesdworld.png'
import Breics from '../../Assets/Images/Breics.png'
import NomadMockup from './mockups/NomadMockup'
import LedgerMockup from './mockups/LedgerMockup'
import InsightAiMockup from './mockups/InsightAiMockup'

const featuredProjects = [
  {
    Mockup: NomadMockup,
    title: 'Nomad — Cross-Platform Travel Booking App',
    description:
      "Led development of a React Native + Node.js travel booking platform used by 40k+ monthly active users. Built offline-first itinerary syncing, biometric auth, and a Node/GraphQL backend on AWS handling real-time price updates across 3 supplier APIs. Cut cold-start time by 45% and shipped to both the App Store and Play Store.",
    tags: ['React Native', 'GraphQL', 'AWS', 'PostgreSQL'],
    github: 'https://github.com/tonylyon7',
    demo: '#',
  },
  {
    Mockup: LedgerMockup,
    title: 'Ledger — SaaS Billing & Analytics Platform',
    description:
      'Architected a multi-tenant SaaS platform for subscription billing and revenue analytics, integrating Stripe for payments and webhooks. Designed an event-driven microservice backend with Node.js, Redis queues, and PostgreSQL, deployed on Kubernetes with zero-downtime rolling releases and full CI/CD via GitHub Actions.',
    tags: ['Next.js', 'Node.js', 'Stripe', 'Kubernetes'],
    github: 'https://github.com/tonylyon7',
    demo: '#',
  },
  {
    Mockup: InsightAiMockup,
    title: 'Insight AI — LLM-Powered Support Assistant',
    description:
      'Built an AI-powered customer support assistant on top of the OpenAI API with a custom RAG pipeline over company knowledge bases, cutting average ticket resolution time by 60%. Full-stack build with a Next.js dashboard, Node.js backend, vector search, and usage analytics for support teams.',
    tags: ['Next.js', 'OpenAI API', 'Node.js', 'Vector DB'],
    github: 'https://github.com/tonylyon7',
    demo: '#',
  },
]

const shippedProjects = [
  {
    image: Breics,
    title: 'Breics — Real Estate Platform with Core Banking Integration',
    description:
      "Built Breics, a real estate marketplace for finding, listing, and letting properties, with state, property-type, and price-based search across daily-refreshed listings. Integrated NCUBE's core banking system directly into the platform to power in-app payments and flexible payment plans for renters, landlords, agents, and investors — bridging property discovery with real financial infrastructure.",
    tags: ['React', 'Core Banking API', 'Search UX', 'Payments'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://breics.ng/',
  },
  {
    image: HouseOfPraise,
    title: 'House of Praise — Church Website',
    description:
      "Designed and built the full website for House of Praise, a worship ministry, with an immersive video-driven homepage, service and event schedules, ministry pages, sermon access, and an online giving flow. Focused on an atmospheric, media-rich experience that reflects the church's worship services.",
    tags: ['React', 'Responsive Design', 'CMS', 'Payments'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://houseofpraise.ng',
  },
  {
    image: Jesdworld,
    title: 'Jesdworld — Shawarma Ordering Platform',
    description:
      'Built an online ordering platform for a shawarma and fast-food business, letting customers browse the menu and place delivery orders directly from the site, with a WhatsApp-integrated ordering flow for fast, low-friction checkout. Designed a warm, appetite-driven brand experience end to end.',
    tags: ['React', 'E-commerce', 'WhatsApp API', 'Responsive Design'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://jesdworld.com',
  },
  {
    image: Mophy,
    title: 'Mophy — Fintech Admin Dashboard',
    description:
      'Built a full payment administration dashboard for a fintech platform, giving super admins real-time visibility into balances, income/outcome trends, wallet usage, and spending breakdowns. Implemented interactive charts, a transaction overview with exportable reports, and a card-based balance widget backed by live data.',
    tags: ['React', 'Chart.js', 'REST API', 'Dashboard UX'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://mophyfintech.netlify.app/',
  },
  {
    image: School,
    title: 'South-West Medical Academy — Enrollment Platform',
    description:
      "Delivered the full marketing and enrollment website for a healthcare training academy, covering program listings, admissions requirements, staff/team profiles, and online payment for registered students. Built for conversion, with a clear enrollment funnel from landing page to signed-up student.",
    tags: ['React', 'Responsive Design', 'Payments', 'CMS'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://swmedicalacademy.com/',
  },
  {
    image: GYM,
    title: 'Gym House — Fitness Social Platform',
    description:
      'Built a dark-themed social platform for fitness enthusiasts, with a real-time post feed, customizable profiles, image/video/audio content sharing, and impression and profile-visit tracking. Integrated sponsored ad placements and Twitter/LinkedIn account linking for cross-platform sharing.',
    tags: ['React', 'Node.js', 'Social Feed', 'Real-time'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://gymhouse07.netlify.app/',
  },
  {
    image: cars,
    title: 'Cars.ng — Vehicle Marketplace UI',
    description:
      'Rebuilt the front-of-site experience for a national car marketplace, including brand/budget-based search, listing filters, and a conversion-focused hero flow for browsing thousands of live vehicle listings. Focused on fast search interactions and a responsive layout across devices.',
    tags: ['React', 'Search UX', 'Responsive Design'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://cars.ng/',
  },
  {
    image: loginApi,
    title: 'Secure Auth Starter Kit',
    description:
      'A production-style authentication template with Sign Up / Sign In flows, protected routes, and session handling wired to a RESTful backend API via Redux. Used as a reusable starting point for client projects that need secure login, logout, and account management out of the box.',
    tags: ['React', 'Redux', 'REST API', 'Auth'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://tonyproject.netlify.app/',
  },
  {
    image: clock,
    title: 'Analog Clock Widget',
    description:
      'A lightweight, dependency-free analog clock widget built with vanilla JavaScript and the Canvas/DOM APIs, driven by a real-time render loop. A small exercise in precise timing logic and pixel-accurate UI.',
    tags: ['JavaScript', 'DOM API', 'UI Widget'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://tonytime.netlify.app/',
  },
  {
    image: note,
    title: 'Sticky Notes App',
    description:
      'A colour-coded sticky notes app with instant create, edit, and delete, persisted client-side so notes survive a page refresh. Built to explore fast, low-friction CRUD UX patterns.',
    tags: ['React', 'Local Storage', 'CRUD'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://tonystickynotes.netlify.app/',
  },
  {
    image: calc,
    title: 'Calculator App',
    description:
      'A real-time arithmetic calculator covering the core operator set with a keypad UI modeled on native mobile calculators. Built to nail edge cases in expression evaluation and input handling.',
    tags: ['JavaScript', 'UI Widget'],
    github: 'https://github.com/tonylyon7',
    demo: 'https://tonycalculator.netlify.app/',
  },
]

const ProjectCard = ({ visual, title, description, tags, github, demo }) => (
  <article className='bg-bg-variant p-5 rounded-[2rem] border border-transparent transition hover:border-primary-variant hover:bg-transparent'>
    {visual}
    <h3 className='mt-5 mb-2 text-primary text-lg'>{title}</h3>
    <p className='text-[0.9rem] text-light mb-4'>{description}</p>
    <div className='flex flex-wrap gap-2 mb-4'>
      {tags.map((tag) => (
        <span key={tag} className='text-[0.7rem] px-3 py-1 rounded-full border border-primary-variant text-primary'>{tag}</span>
      ))}
    </div>
    <div className='flex gap-4 mb-4'>
      <a href={github} target='_blank' rel='noreferrer' className='btn'>Github</a>
      <a href={demo} className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
    </div>
  </article>
)

const Portfolio = () => {
  return (
    <section id='Portfolio'>
        <h5>My recent work</h5>
        <h2>Portfolio</h2>

        <div className='container grid grid-cols-2 gap-6 max-[1024px]:grid-cols-2 max-[1024px]:gap-4 max-[1024px]:m-4 max-[600px]:grid-cols-1'>
            {featuredProjects.map(({ Mockup, ...project }) => (
              <ProjectCard
                key={project.title}
                {...project}
                visual={
                  <div className='rounded-2xl overflow-hidden h-48'>
                    <Mockup />
                  </div>
                }
              />
            ))}
            {shippedProjects.map(({ image, ...project }) => (
              <ProjectCard
                key={project.title}
                {...project}
                visual={
                  <div className='rounded-2xl overflow-hidden h-48'>
                    <img src={image} className='w-full h-full object-cover object-top' alt={project.title} />
                  </div>
                }
              />
            ))}
        </div>
    </section>
  )
}

export default Portfolio
